
import React from 'react';
import { Box, Grid } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
// ... imports ...
import {
  StatsCard,
  IconContainer,
  CardTitle,
  MetricValue,
  TrendText,
  SubInfoText,
  SuccessChip,
  UnfilledChip,
  GreySpan
} from './styles';
import ShiftFulfillmentIcon from '../../../../assets/reports/shift-fulfillment.svg';
import TotalShiftsIcon from '../../../../assets/reports/total-shifts.svg';
import WorkerAttendanceIcon from '../../../../assets/reports/worker-attendance.svg';
import { IFacilityReportStats } from '../../../../modules/facility/types';
import { CircularProgress } from '@mui/material';

interface PerformanceStatsProps {
  stats: IFacilityReportStats | null;
  loading: boolean;
}

const PerformanceStats: React.FC<PerformanceStatsProps> = ({ stats, loading }) => {
  if (loading) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}><CircularProgress /></Box>;
  }

  const fulfillmentRate = stats?.shift_fulfillment_rate?.value !== undefined
    ? stats.shift_fulfillment_rate.value.toFixed(1) + '%'
    : '0%';

  const trendText = stats?.shift_fulfillment_rate?.trend || '+0% from last month';

  const totalShifts = stats?.total_shifts_created?.value || 0;
  const filledShifts = stats?.total_shifts_created?.filled || 0;
  const unfilledShifts = stats?.total_shifts_created?.unfilled || 0;

  const attendanceRate = stats?.worker_attendance?.value !== undefined
    ? stats.worker_attendance.value.toFixed(1) + '%'
    : '0%';

  const noShows = stats?.worker_attendance?.no_shows || 0;

  return (
    <Grid container spacing={3} sx={{ mb: 4 }}>
      {/* Shift Fulfillment Rate */}
      <Grid size={{ xs: 12, md: 4 }}>
        <StatsCard elevation={0}>
          <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
            <IconContainer>
              <img src={ShiftFulfillmentIcon} alt="Shift Fulfillment" />
            </IconContainer>
            <Box>
              <CardTitle>
                Shift Fulfillment Rate
              </CardTitle>
              <MetricValue variant="h4">
                {fulfillmentRate}
              </MetricValue>
              <TrendText>
                <TrendingUpIcon fontSize="small" color="inherit" />
                <GreySpan>{trendText}</GreySpan>
              </TrendText>
            </Box>
          </Box>
        </StatsCard>
      </Grid>

      {/* Total Shifts Created */}
      <Grid size={{ xs: 12, md: 4 }}>
        <StatsCard elevation={0}>
          <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
            <IconContainer>
              <img src={TotalShiftsIcon} alt="Total Shifts" />
            </IconContainer>
            <Box>
              <CardTitle>
                Total Shifts Created
              </CardTitle>
              <MetricValue variant="h4">
                {totalShifts}
              </MetricValue>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <SuccessChip
                  label={`${filledShifts} Filled`}
                  size="small"
                />
                <UnfilledChip
                  label={`${unfilledShifts} Unfilled`}
                  size="small"
                />
              </Box>
            </Box>
          </Box>
        </StatsCard>
      </Grid>

      {/* Worker Attendance */}
      <Grid size={{ xs: 12, md: 4 }}>
        <StatsCard elevation={0}>
          <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
            <IconContainer>
              <img src={WorkerAttendanceIcon} alt="Worker Attendance" />
            </IconContainer>
            <Box>
              <CardTitle>
                Worker Attendance (Avg)
              </CardTitle>
              <MetricValue variant="h4">
                {attendanceRate}
              </MetricValue>
              <SubInfoText>
                {noShows > 0 ? `${noShows} No-Shows` : '-- No-Shows'}
              </SubInfoText>
            </Box>
          </Box>
        </StatsCard>
      </Grid>
    </Grid>
  );
};

export default PerformanceStats;
